import React from 'react';
import { Link } from 'react-router-dom';
import './HowItWorks.css';

const steps = [
  {
    step: 1,
    title: 'Asset Received',
    status: 'Completed',
    details: [
      'Transaction received',
      'Network confirmed',
      'Asset registered',
      'Status: Completed',
    ],
  },
  {
    step: 2,
    title: 'Security Screening',
    status: 'Completed',
    details: [
      'Transaction validation',
      'Wallet risk analysis',
      'Fraud detection',
      'Compliance check',
      'Status: Completed',
    ],
  },
  {
    step: 3,
    title: 'Ownership Verification',
    status: 'In Progress',
    details: [
      'Identity verification',
      'Document review',
      'Wallet ownership check',
      'Authorization validation',
      'Status: In Progress',
    ],
  },
  {
    step: 4,
    title: 'Vault Storage',
    status: 'Pending',
    details: [
      'Moved to cold storage',
      'Multi-signature secured',
      'Encrypted storage',
      'Continuous monitoring',
      'Status: Pending',
    ],
  },
  {
    step: 5,
    title: 'Release Approval',
    status: 'Pending',
    details: [
      'Review release request',
      'Multi-level approval',
      'Final authorization',
      'Release scheduled',
      'Status: Pending',
    ],
  },
  {
    step: 6,
    title: 'Asset Transfer',
    status: 'Pending',
    details: [
      'Transfer to verified wallet',
      'Network confirmation',
      'Transaction completed',
      'Record updated',
      'Status: Pending',
    ],
  },
];

const statusColors = {
  Completed: '#10b981',
  'In Progress': '#f59e0b',
  Pending: '#94a3b8',
};

function HowItWorks() {
  return (
    <div className="how-page">

      {/* ── Back to Home arrow ── */}
      <Link
        to="/"
        style={{
          position: 'fixed',
          top: '1.25rem',
          left: '1.25rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.4rem',
          color: 'rgba(255,255,255,0.75)',
          fontSize: '0.9rem',
          fontWeight: 500,
          zIndex: 100,
          transition: 'color 0.2s',
          textDecoration: 'none',
        }}
        onMouseEnter={e => e.currentTarget.style.color = '#fff'}
        onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.75)'}
      >
        ← Home
      </Link>

      <div className="how-hero">
        <h1>How It Works</h1>
        <p>Every asset that enters Recovery Vault goes through our rigorous 6‑step pipeline, ensuring maximum security and compliance.</p>
      </div>

      <div className="timeline">
        {steps.map((s, idx) => (
          <div key={idx} className={`timeline-row ${idx % 2 === 0 ? 'left' : 'right'}`}>
            <div className="timeline-marker">
              <div
                className="marker-circle"
                style={{ background: statusColors[s.status] }}
              >
                {s.status === 'Completed' ? '✓' : s.step}
              </div>
              {idx < steps.length - 1 && <div className="marker-line"></div>}
            </div>
            <div className="timeline-card">
              <div className="card-header">
                <span className="step-badge" style={{ background: statusColors[s.status] }}>
                  Step {s.step}
                </span>
                <span
                  className="status-badge"
                  style={{
                    background: statusColors[s.status] + '20',
                    color: statusColors[s.status],
                    border: `1px solid ${statusColors[s.status]}40`,
                  }}
                >
                  {s.status}
                </span>
              </div>
              <h3>{s.title}</h3>
              <ul className="detail-list">
                {s.details.map((detail, i) => (
                  <li key={i}>
                    <span className="check-icon" style={{ color: statusColors[s.status] }}>
                      {s.status === 'Completed' ? '✓' : s.status === 'In Progress' ? '⏳' : '○'}
                    </span>
                    {detail}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default HowItWorks;